import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import PageTitle from '../features/ui/util/page_title'
import MarketplaceLayout from '../layouts/marketplace_layout'
import { me, meBusinesses } from '../initial_state'
import {
  LinkFooter,
  ProPanel,
  GabAdTopPanel,
  ProgressPanel,
} from '../features/ui/util/async_components'
import WrappedBundle from '../features/ui/util/wrapped_bundle'
import TabBar from '../components/tab_bar'
import { BREAKPOINT_EXTRA_SMALL, MODAL_UNAUTHORIZED } from '../constants'
import Button from '../components/button'
import List from '../components/list'
import Text from '../components/text'
import MarketplaceListingFilterPanel from '../components/panel/marketplace_listing_filter_panel'
import MarketplaceListingCategoriesPanel from '../components/panel/marketplace_listing_categories_panel'
import { openModal } from '../actions/modal'

class MarketplaceListingCategoriesPage extends React.PureComponent {

  handleOnOpenModal = () => {
    this.props.dispatch(openModal(MODAL_UNAUTHORIZED))
  }

  render() {
    const { children, isXS } = this.props

    const sidebarLayout = [
      <WrappedBundle key='marketplace-categories-page-ad-panel' component={GabAdTopPanel} componentParams={{ pageKey: 'marketplace-categories.sidebar', position: 1 }} />,
      ProgressPanel,
      <WrappedBundle key='marketplace-categories-page-pro-panel' component={ProPanel} />,
      LinkFooter,
    ].filter(Boolean)

    const tabs = [
      {
        title: 'Home',
        to: '/marketplace',
        icon: 'shop',
      },
      {
        title: 'Businesses',
        to: '/businesses',
        icon: 'ul-list',
      },
      !me && {
        title: 'Categories',
        to: '/marketplace/categories',
        icon: 'ol-list',
        hideArrow: true,
        shouldHighlight: true,
        isActive: true,
      },
      !!me && !!meBusinesses && {
        title: 'My Businesses',
        to: '/businesses/dashboard',
        icon: 'apps',
      },
      !!me && {
        title: 'My Listings',
        to: '/marketplace/dashboard',
        icon: 'apps',
      },
      !!me && {
        title: 'Saved',
        to: '/marketplace/saved',
        icon: 'bookmark',
      },
    ].filter(Boolean)

    const sidebarChildren = [
      <div key='mlcpcd-1' className={[_s.d, _s.w100PC, _s.boxShadowNone, _s.boxShadowNoneBg].join(' ')}>
        <List items={tabs} size='large' padded />
      </div>,
      (<div key='mlcpcd-2' className={[_s.d, _s.w100PC, _s.px5, _s.pt5].join(' ')}>
        <Button
          isBlock
          radiusSmall
          to={!!me ? '/marketplace/create' : undefined}
          onClick={!me ? this.handleOnOpenModal : undefined}
        >
          <Text color='inherit' weight='medium' size='medium' align='center'>Create Listing →</Text>
        </Button>
      </div>),
      (<div key='mlcpcd-3' className={[_s.d, _s.w100PC, _s.px5, _s.pt10].join(' ')}>
        <Button
          isBlock
          radiusSmall
          to='/marketplace/business/join'
          backgroundColor='brandLight'
          color='brand'
        >
          <Text color='inherit' weight='medium' size='medium' align='center'>List your Business →</Text>
        </Button>
      </div>),
      <MarketplaceListingFilterPanel key='mlcpcd-4' noPanel />,
      <MarketplaceListingCategoriesPanel key='mlcpcd-5' noPanel />,
    ]

    const xsTabs = !isXS ? undefined : [
      {
        title: 'Home',
        to: '/marketplace',
      },
      {
        title: 'Jobs',
        to: '/marketplace/listings/jobs',
      },
      // {
      //   title: 'Categories',
      //   to: '/marketplace/categories',
      //   active: true,
      // },
      {
        title: 'My Listings',
        to: '/marketplace/dashboard',
      },
    ]

    return (
      <MarketplaceLayout
        showBackBtn
        page='marketplace'
        title='Marketplace'
        sidebarChildren={sidebarChildren}
        layout={sidebarLayout}
      >
        <PageTitle path='Marketplace' />

        {
          isXS &&
          <div className={[_s.d, _s.w100PC, _s.h40PX, _s.z6, _s.top0, _s.right0, _s.left0, _s.posSticky, _s.bgPrimary, _s.borderBottom1PX, _s.borderColorSecondary].join(' ')}>
            <TabBar tabs={xsTabs} shouldGrow />
          </div>
        }

        {children}
      </MarketplaceLayout>
    )
  }

}

const mapStateToProps = (state) => ({
  isXS: state.getIn(['settings', 'window_dimensions', 'width']) <= BREAKPOINT_EXTRA_SMALL,
})

MarketplaceListingCategoriesPage.propTypes = {
  children: PropTypes.object,
}

export default connect(mapStateToProps)(MarketplaceListingCategoriesPage)
